import * as i0 from '@angular/core';
import { Directive, Input } from '@angular/core';

class SubscribeDirective {
    constructor(tpl, cdr, vcr) {
        this.tpl = tpl;
        this.cdr = cdr;
        this.vcr = vcr;
        this.subscription = null;
        this.viewRef = null;
        this.context = {
            $implicit: undefined,
            subscribe: undefined,
            error: undefined,
            completed: false,
        };
        this.strategy = 'markForCheck';
    }
    set subscribe(source) {
        this.subscription?.unsubscribe();
        if (!source) {
            return;
        }
        this.subscription = source.subscribe({
            next: (value) => {
                this.context.$implicit = value;
                this.context.subscribe = value;
                this.onChange();
            },
            error: (err) => {
                console.error(err);
                this.context.error = err;
                this.onChange();
            },
            complete: () => {
                this.context.completed = true;
                this.onChange();
            },
        });
    }
    static ngTemplateContextGuard(directive, context) {
        return true;
    }
    ngOnInit() {
        this.viewRef = this.vcr.createEmbeddedView(this.tpl, this.context);
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
        this.subscription = null;
        this.viewRef = null;
    }
    onChange() {
        if (this.strategy === 'markForCheck') {
            this.cdr.markForCheck();
        }
        else {
            this.viewRef?.detectChanges();
        }
    }
}
SubscribeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: SubscribeDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ChangeDetectorRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
SubscribeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.1", type: SubscribeDirective, isStandalone: true, selector: "[subscribe]", inputs: { strategy: "strategy", subscribe: "subscribe" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.1", ngImport: i0, type: SubscribeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[subscribe]',
                    standalone: true
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ChangeDetectorRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { strategy: [{
                type: Input
            }], subscribe: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { SubscribeDirective };
//# sourceMappingURL=ngneat-subscribe.mjs.map
